import PropTypes from 'prop-types';

const PrintSizeType = PropTypes.shape({
  size: PropTypes.string,
  title: PropTypes.string,
  finish: PropTypes.string,
  quantity: PropTypes.number,
  price: PropTypes.number,
  total_price: PropTypes.number,
  sku: PropTypes.string,
  partner_id: PropTypes.string,
  border: PropTypes.string,
  print_finish_key: PropTypes.string,
});

export default PrintSizeType;
